import { TextPage } from "../TextPage/TextPage"
import "./SelectedColorsComponent.scss"

const SelectedColorsComponent = ({
    colors,
    currentColor,
    setCurrentColor,
    fetchSetColor
}) => {

    return (
        <div className="selected-colors-component">
            <TextPage
                text={<>Выбран: {currentColor?.color_name ? currentColor?.color_name : '-'}</>}
            />

            <div className="selected-colors-component__content">
                {colors?.map((el) => {
                    return <div
                        onClick={(e) => {
                            fetchSetColor(el)
                            setCurrentColor(el)
                        }}
                        className={currentColor?.color == el?.color ?
                            "selected-colors-component__color-block_active"
                            :
                            "selected-colors-component__color-block"
                        }
                        style={{ background: el?.color }}
                        key={el?.color}>
                    </div>
                })}
            </div>
        </div>
    )
}

export { SelectedColorsComponent }